<template>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md4>
        <v-card class="elevation-12">
          <v-toolbar dark color="primary">
            <v-toolbar-title>Reset your password</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            If you have forgotten your password, enter your email address below and click Send Reset Email.
            <v-form>
              <v-text-field v-model="username" prepend-icon="person" name="login" label="Email" type="text"></v-text-field>
              
            </v-form>
          </v-card-text>
          <v-card-actions>
          
            <v-btn @click="resetPassword()" color="primary">Send Reset Email</v-btn>
          </v-card-actions>
            <v-snackbar
                v-model="snackbar"
                :color="snackbarType"
                :timeout="snackbarTimeout"
                top
              >
                {{ snackbarMessage }}
                <v-btn dark text @click="snackbar = false">
                  Close
                </v-btn>
              </v-snackbar>
        </v-card>            
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import firebase from 'firebase';
export default {
  name: 'ForgotPassword',
  data () {
    return {
      username:'',
      snackbar:false,
      snackbarMessage:'',
      snackbarType:'error',
      snackbarTimeout: 10000,
    }
  },
  methods: {
    resetPassword() {
      firebase.auth().sendPasswordResetEmail(this.username).then(() => {
        // Email sent.
        this.snackbarType = 'success';
        this.snackbarTimeout = 10000;
        this.snackbarMessage = 'Reset password email successfully sent.  Check your inbox.'
        this.snackbar = true;

      }).catch(function(error) {
        // An error happened.
        console.log(error);
        this.snackbarTimeout = 0;
        this.snackbarMessage ='There was an error sending the email.'
        this.snackbarType = 'error';
        this.snackbar = true;
      });
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>